import { useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormWatch, IFormValues } from 'routes/Main/type';

import { Grid, Box, MenuItem } from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers';
import { AccessTime } from '@mui/icons-material';

import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContent';
import RowContentPre from './components/RowContentPre';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormWatch, IFormValues {
  disabled?: boolean;
}

const EmergencyRecord = (props: Props) => {
  const { disabled, register, watch, getValues, setValue } = props;

  const timePickers = [
    {
      title: 'Thời gian xảy ra\ntai nạn',
      variable: 'emergency_information.accident_time',
    },
    { title: 'Thời gian tới', variable: 'emergency_information.arrival_time' },
  ];

  return (
    <>
      <SectionTitle title="Quá trình điều chuyển" />
      <RowContainer xs={12}>
        <RowContentPre
          title="Ngày xảy ra
tai nạn"
          titleRatio={1}
          childrenRatio={2}
        >
          <Form.MuiTextField
            type="date"
            InputLabelProps={{ shrink: true }}
            required={false}
            disabled={disabled}
            {...register('emergency_information.accident_date')}
          />
        </RowContentPre>
        {timePickers.map(({ title, variable }, _) => {
          if (title === 'Thời gian xảy ra\ntai nạn') {
            return (
              <RowContentPre
                key={variable}
                title={title}
                titleRatio={1}
                childrenRatio={2}
              >
                <MobileTimePicker
                  disabled={disabled}
                  value={watch(variable) || null}
                  onChange={value => setValue(variable, value)}
                  renderInput={params => (
                    <MuiTextField
                      {...params}
                      required={false}
                      placeholder="00:00"
                      InputProps={{ endAdornment: <AccessTime /> }}
                    />
                  )}
                />
              </RowContentPre>
            );
          }
          return (
            <RowContent
              key={variable}
              title={title}
              titleRatio={1}
              childrenRatio={2}
            >
              <MobileTimePicker
                disabled={disabled}
                value={watch(variable) || null}
                onChange={value => setValue(variable, value)}
                renderInput={params => (
                  <MuiTextField
                    {...params}
                    required={false}
                    placeholder="00:00"
                    InputProps={{ endAdornment: <AccessTime /> }}
                  />
                )}
              />
            </RowContent>
          );
        })}
        <RowContent title="Phương thức" titleRatio={1} childrenRatio={2}>
          <Box display="flex">
            <Form.MuiTextField
              select
              required={false}
              disabled={disabled}
              defaultValue={getValues('emergency_information.visit_method')}
              {...register('emergency_information.visit_method')}
            >
              <MenuItem value="ambulance">Xe cứu thương</MenuItem>
              <MenuItem value="stretcher">Cáng</MenuItem>
              <MenuItem value="wx">Xe lăn</MenuItem>
              <MenuItem value="police">Cảnh sát</MenuItem>
              <MenuItem value="medics">Nhân viên y tế</MenuItem>
            </Form.MuiTextField>
          </Box>
        </RowContent>
        <Grid item xs={12}>
          <Form.MuiTextField
            multiline
            minRows={8}
            disabled={disabled}
            required={false}
            {...register('emergency_information.memo')}
            placeholder={'Khiếu nại chính'}
          />
        </Grid>
      </RowContainer>
    </>
  );
};

export default EmergencyRecord;
